import $store from '@/store.js'
import Tool from '@/assets/js/utils.js'
let protocol = window.location.protocol
/*
 * 加载serviceList.js并存储全局变量供media及公共header使用
 */
function loadSudoku (data) {
  window.serviceList = {
    userserviceApi: `${protocol}//${data.userAuthUrl}`, // "cc-ms-dev.tvunetworks.com/userAuth"， userauth地址           （可按照服务后端配置自行绑定）
    newUserServiceUrl: `${protocol}//${data.serviceListUrl}`, // "cc-ms-dev.tvunetworks.com/serviceListUI"，
    shareUrl: `${protocol}//${data.shareServerUrl}`, // 用于header
    mediaApiUrl: `${protocol}//${data.mediaApiUrl}`, // 用于media接口
    mediaServerUrl: `${protocol}//${data.mediaServerUrl}`, // 用于media js css
    blobUrl: `${protocol}//${data.blobUrl}`
  }
  window.versionNewsObj = {
    code: data.versionCode,
    pageSize: 10,
    versionUrl: `${protocol}//${data.versionUrl}`,
    versionApiUrl: `${protocol}//${data.versionApiUrl}`,
    theme: 'black'
  }
}
function googleAnalytics (gaCode) {
  // Global site tag (gtag.js) - Google Analytics
  (function (h, o, t, j, a, r) {
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + j
    a.appendChild(r)
  })(window, document, 'https://www.googletagmanager.com/gtag/js?id=', gaCode)
  window.dataLayer = window.dataLayer || []

  window.gtag = function () { dataLayer.push(arguments) }

  gtag('js', new Date())
  gtag('config', gaCode)
}
// 加载mediaCommon
function loadMediaJs (callback) {
  if (document.getElementById('mediaCommon') && typeof callback == 'function') {
    callback()
  } else {
    let url = `${protocol}//${$store.state.common.baseUrl.mediaServerUrl}/js/mediaCommon.js`
    // let url = 'https://sunny-dev8088.tvunetworks.com/js/mediaCommon.js'
    Tool.dynamicLoadJs(
      url,
      function () {
        if (typeof callback == 'function') {
          callback()
        }
      },
      'mediaCommon'
    )
  }
}
export { loadSudoku, loadMediaJs, googleAnalytics }
